define.alias("shared/components/shared/page-picker-legacy", "media/components/shared/page-picker-legacy");